<template>
    <el-dialog  title="编辑接口" :visible.sync="showBlock" :destroy-on-close="true" :close-on-click-modal="false" width="450px" :before-close="closedBtn">
        <el-form :model="fromData" ref="fromData" label-width="80px" class="demo-ruleForm">
            <el-form-item  label="目录结构"  prop="name">
                <TReeBlock keyVal="parentId" ref="parentId" :options="menuList" width="330" childKey="children" @getVal="getVal" ></TReeBlock>
            </el-form-item>
            <el-form-item  label="请求类型"  prop="name">
                <el-select v-model="method" placeholder="请选择请求类型" style="width:330px">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"  :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="接口名称"  prop="name">
                <el-input v-model.number="fromData.name" autocomplete="off" maxlength="10" placeholder="请输入接口名称"></el-input>
            </el-form-item>
            <el-form-item  label="接口URL"  prop="url">
                <input type="text" class="interFace" v-model.number="fromData.url" oninput = "value=value.replace(/[\u4E00-\u9FA5]/g,'')" maxlength="100" placeholder="请输入接口URL" />
            </el-form-item>
            <el-form-item  label="备注信息"  prop="url">
                <el-input v-model.number="fromData.example" placeholder="请输入案列" type="textarea" :autosize="{ minRows: 8, maxRows: 16}" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <div class="warp-BTn dialog-footer">
                    <el-button @click="closedBtn">取消</el-button>
                    <el-button type="primary" @click="submitBtn">提交</el-button>
                </div> 
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun} from '@/utils/httpFun'
  import TReeBlock from '@/components/component-block/block-newTreeInput.vue'
import { putFun } from '../../../utils/httpFun'

  export default{
     components:{
        TReeBlock:TReeBlock,
     },
     data:()=>({
        showBlock:false,
        options: [{
          value: 'GET',
          label: 'GET'
        }, {
          value: 'POST',
          label: 'POST'
        }, {
          value: 'DELETE',
          label: 'DELETE'
        }, {
          value: 'PUT',
          label: 'PUT'
        }],
        method:"-",
        menuList:[],
        fromData:{
            parentId:0,
            name:"", 
            url: '',
            example:"",
            systemCode:"",
            subsystemId:""
        }
     }),

     created(){
       
     },
     methods:{

        //获取下拉的数据
        getVal(ev){
           this.fromData.parentId = ev.val.id
        },
 
        //新增的数据
        async submitBtn(){
            let parms = {
                systemCode:this.fromData.systemCode,
                subsystemId:this.fromData.subsystemId,
                name:this.fromData.name,
                id:this.fromData.id,
                url:this.fromData.url,
                method:!this.method ? "--":this.method,
                parentId:this.fromData.parentId,
                example:this.fromData.example,
                operator:this.$store.state.operator
            }
            await putFun(operate.JIEKOUDUPDATE,parms,res=>{
                this.$parent.getDatas()
                this.closedBtn()
            })
        },

        //开启弹窗
        showBlockFun(ev){
            
            this.menuList = ev.menuList
            this.method = ev.val.method
            this.fromData={
                    parentId:ev.val.parentId,
                    id:ev.val.id,
                    name:ev.val.name, 
                    url: ev.val.url,
                    example:ev.val.example,
                    systemCode:ev.systemCode,
                    subsystemId:ev.subsystemId
            }
            this.showBlock = true
            this.$nextTick(res=>{
                this.$refs.parentId.setVal(ev.val.parentId+"")
            })
        },

        //关闭弹窗并刷新
        closedBtn(){
            this.showBlock = false
        }

     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #4D5C72;
        letter-spacing: 0;
   }
   .interFace{
      height: 40px;
      border: 1px solid #DCDFE6;
      outline: none;
      padding-left: 17px;
      box-sizing: border-box;
      width: 100%;
      border-radius: 4px;
   }
   .interFace:focus{
      border: 1px solid #409EFF;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>